/* eslint-disable no-unused-vars */
import { Select } from '@salt/components';
import React, { useCallback, useEffect, useState } from 'react';
import { getCategories } from '../../../api/reports';

const StepCategories = ({ project, setProject }) => {
  const [categories, setCategories] = useState([]);

  const fetchData = useCallback(async () => {
    // setLoading(true);
    try {
      const categoryData = await getCategories();

      setCategories(categoryData);
    } catch (error) {
      console.error(error.message);
    }
    // setLoading(false);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const handleCategoryChange = useCallback(
    (newVal) => {
      let tmpVal = (project.categories?.length > 0 && project.categories?.split(',')) || [];

      if (tmpVal.includes(newVal)) {
        tmpVal = tmpVal.filter((v) => v !== newVal);
      } else {
        tmpVal.push(newVal);
      }
      setProject({ ...project, categories: tmpVal.join(',') });
    },
    [project.categories, categories]
  );

  const customRenderValue = useCallback(
    (val) => {
      const selectedItems = val?.split(',') || [];
      if (categories.length > 0 && selectedItems.length > 0) {
        return (
          <div className="flex flex-wrap">
            {selectedItems.map((i) => {
              // eslint-disable-next-line eqeqeq
              const cat = categories.find((c) => c.id == i);
              return (
                <div key={i} className="m-1 pointer-events-none">
                  <button
                    type="button"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleCategoryChange(String(cat.id));
                    }}
                    className="group/card pointer-events-auto bg-[#37C2D7]/10 text-[#37C2D7] py-1 px-2 rounded-full flex items-center justify-center"
                  >
                    <span className="group-hover/card:text-[#37C2D7]/60">{cat.name}</span>
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 7 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="ml-2 mr-1"
                    >
                      <path
                        className="fill-[#37C2D7] group-hover/card:fill-[#37C2D7]/60"
                        d="M4.87725 0.207583L3.03576 2.04907L1.19427 0.207584C0.917449 -0.069241 0.484158 -0.0692409 0.207333 0.207584C-0.0694916 0.484409 -0.0694915 0.917699 0.207333 1.19452L2.04882 3.03601L0.207333 4.8775C-0.0694915 5.15432 -0.0694916 5.58761 0.207333 5.86444C0.484158 6.14126 0.917449 6.14126 1.19427 5.86444L3.03576 4.02295L4.87725 5.86444C5.15407 6.14126 5.58736 6.14126 5.86419 5.86444C6.14101 5.58761 6.14101 5.15432 5.86419 4.8775L4.0227 3.03601L5.86419 1.19452C6.14101 0.917699 6.14101 0.484409 5.86419 0.207584C5.58736 -0.0692409 5.15407 -0.069241 4.87725 0.207583Z"
                      />
                    </svg>
                  </button>
                </div>
              );
            })}
          </div>
        );
      }
      return '';
    },
    [categories, handleCategoryChange, project.categories]
  );

  return (
    <div>
      <div className="text-base mb-4">Select which SMART categories users can report on.</div>
      <div className="text-[12px] mb-4">
        These report categories will be displayed within the ‘SMART’ tab of the Salt application.
        Please select a <b>minimum of 1</b> category and a <b>maximum of 9</b> categories.
      </div>
      <div className="w-full mt-8">
        <Select
          onClick={handleCategoryChange}
          width="w-full"
          labelBackgroundClass={`group-focus:bg-secondary-light group-focus:bg-secondary-light ${project.categories?.length > 0 ? 'bg-secondary-light' : ''}`}
          backgroundClass="bg-secondary-light"
          multiSelect
          placeholder="Select Report Categories"
          dropdownType="sticky"
          maxSelected={9}
          renderItems={categories.map((r) => ({
            id: String(r.id),
            value: r.name,
            render: () => (
              <div key={r.id} className="flex items-center">
                <img
                  style={{ width: '30px', height: '30px' }}
                  src={`data:image/svg+xml;base64,${r.icon}`}
                  alt={`${r.id}-icon`}
                />
                <span className="mx-2">{r.name}</span>
              </div>
            ),
          }))}
          value={project.categories}
          customRenderValue={customRenderValue}
        />
      </div>
    </div>
  );
};

export default StepCategories;
